module.exports = __webpack_public_path__ + "img/iconfont.52618b7c.svg";